import { TEMPLATE_LIST_V2 } from "@/api/apiEndpoints";
import { canv } from "@/canv/global";
import { MakeRequest } from "@/canv/utils";

export type LoadedTemplate = {
    title: string;
    view: string;
    templateName: string;
};

export type ApiGetTemplateListResponse = LoadedTemplate[];

export type TemplateData = {
    name: string;
    picUid: string;
    uid: string;
};

export type TemplateResponseData = {
    templates: TemplateData[];
};

export const getTemplateSrc = () => {
    const apiSsl = canv.getInitDataProp("isSSL") ? "https" : "http";
    return `${apiSsl}://${canv.getInitDataProp("appDomain")}/api/v2/static/preview/`;
};

export const ApiGetTemplateList = async (): Promise<ApiGetTemplateListResponse | undefined> => {
    const templateSrc = getTemplateSrc();

    try {
        const res: TemplateResponseData = await MakeRequest(TEMPLATE_LIST_V2, {
            token: canv.getInitDataProp("userToken"),
        });

        if ("templates" in res && Array.isArray(res.templates)) {
            return res.templates.map((template) => ({
                title: template.name,
                view: templateSrc + template.picUid,
                templateName: template.uid,
            }));
        }
        return [];
    } catch (err) {
        console.error(err);
    }
};
